import React from "react";
import "./styles/AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-container">
      <section className="about-header">
        <h1>About Us</h1>
      </section>
      <div className="benefits-section">
        <h2>
          Discover Our Top <span className="span-benefits">Benefits</span>
        </h2>
        <p className="benefits-subtitle">
          At ExploreEase, we transform how you manage and experience your
          travels. Our platform is designed to be your personal travel
          concierge—helping you organize, track, and remember every journey
          after you book.
        </p>
        <div className="benefits-cards">
          <div className="benefit-card">
            <img src="/Images/about-travel.svg" alt="Trip Organization Icon" />
            <h3>Smart Trip Management</h3>
            <p>
              Organize all your travel details in one place. Track budgets,
              split expenses with travel companions, and get AI-powered packing
              suggestions tailored to your destination and activities.
            </p>
          </div>
          <div className="benefit-card">
            <img src="/Images/about-plane-ticket.svg" alt="Travel Tools Icon" />
            <h3>Intelligent Travel Tools</h3>
            <p>
              Stay on top of expenses with our budget tracker, never forget
              essentials with our smart packing assistant, and get real-time
              weather updates to prepare for your destination.
            </p>
          </div>
          <div className="benefit-card">
            <img
              src="/Images/about-guide.svg"
              alt="Personalized Insights Icon"
            />
            <h3>Personalized Insights</h3>
            <p>
              Receive AI-powered recommendations based on your destination,
              season, and activities. Capture memories with our travel journal
              and get local insights to enhance every moment of your journey.
            </p>
          </div>
        </div>
      </div>
      <div className="cherished-memories-section">
        <div className="cherished-memories">
          <h2>Every Moment Becomes a Cherished Memory</h2>
          <p>
            ExploreEase is more than a planning tool—it's your personal travel
            companion from the moment you book to the memories you preserve. We
            believe travel is a meaningful experience that transforms and
            inspires, and we're here to help you make the most of every journey.
          </p>
        </div>
        <div className="cherished-memories-img">
          <img src="/Images/about-world-map.svg" alt="World Map" />
        </div>
      </div>
      <div
        className="download-now-container"
        style={{
          background: "linear-gradient(to top, #8ECBDB 14%, #FFFFFF 100%)",
        }}
      >
        <div className="download-now-section">
          <div className="download-now-intro">
            <h1>Start Your Journey</h1>
            <h3>
              Your ultimate travel management companion. Organize trips, track
              budgets, and preserve memories.
            </h3>
            <p>
              Get started with ExploreEase and transform how you experience
              travel.
            </p>
            <div className="download-app-store-links">
              <button
                className="get-started-btn"
                style={{
                  backgroundColor: "#5bad72",
                  color: "white",
                  padding: "12px 32px",
                  borderRadius: "8px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Get Started Free
              </button>
            </div>
          </div>
          <div className="download-now-phone-screens">
            <img
              src="./Images/downloadNow-phoneScreens.svg"
              alt="iPhone Screens"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
